<template>
    <v-data-table class="mx-2 " :loading="loading" :disabled="loading" :headers="headers" :items="materialesFiltered"
        :item-class="itemRowBackground">
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn class="mr-2" :disabled="disabled" color="primary" outlined @click="handleNew()">
                    Insertar material
                </v-btn>
                <slot></slot>
            </v-toolbar>
        </template>
        <!-- v-if="showOriginalValues" -->
        <template v-slot:item.qty="{ item }">
            <span :class="getItemClass(item.qty, item.originalQty)">
                {{ item.qty }}
            </span>
        </template>

        <!-- v-if="showOriginalValues" -->
        <template v-slot:item.unitPrice="{ item }">
            <span :class="getItemClass(item.unitPrice, item.originalUnitPrice)">
                {{ item.unitPrice }}
            </span>
        </template>

        <!-- v-if="showOriginalValues" -->
        <template v-slot:item.discount="{ item }">
            <span :class="getItemClass(item.discount, item.originalDiscount)">
                {{ item.discount }}
            </span>
        </template>


        <!-- ***** para editar inline ***** -->
        <!-- <template v-slot:item.qty="{ item }">
        <v-edit-dialog :return-value.sync="item.qty" @save="reset" @close="reset">
            {{ item.qty }}
            <template v-slot:input>
                <v-text-field v-model="item.qty" label="Editar" single-line v-if="!disabled">
                </v-text-field>
            </template>
        </v-edit-dialog>
    </template> -->

        <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="handleEdit(item)">
                mdi-pencil
            </v-icon>
            <v-icon small :disabled="disabled" @click="handleDelete(item)">
                mdi-delete
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>

const defaultHeaders = [
    {
        text: "Código producto",
        align: "start",
        filterable: true,
        sortable: true,
        value: "no",
    },
    {
        text: "Descripción",
        align: "start",
        filterable: true,
        sortable: true,
        value: "description",
    },
    {
        text: "Unidades",
        align: "start",
        filterable: false,
        sortable: true,
        value: "qty",
    },
    {
        text: "Precio/u (€)",
        align: "start",
        filterable: true,
        sortable: true,
        value: "unitPrice",
    },
    {
        text: "Descuento (%)",
        align: "start",
        filterable: true,
        sortable: true,
        value: "discount",
    },
    {
        text: "",
        value: "actions",
        sortable: false,
    },
]

const originalHeaders = [
    {
        text: "Código producto",
        align: "start",
        filterable: true,
        sortable: true,
        value: "no",
    },
    {
        text: "Descripción",
        align: "start",
        filterable: true,
        sortable: true,
        value: "description",
    },
    {
        text: "Unidades",
        align: "start",
        filterable: false,
        sortable: true,
        value: "qty",
    },
    {
        text: "Unidades orig.",
        align: "start",
        filterable: false,
        sortable: true,
        value: "formattedOriginalQty",
    },
    {
        text: "Precio/u (€)",
        align: "start",
        filterable: true,
        sortable: true,
        value: "unitPrice",
    },
    {
        text: "Precio/u orig.(€)",
        align: "start",
        filterable: true,
        sortable: true,
        value: "formattedOriginalUnitPrice",
    },
    {
        text: "Descuento (%)",
        align: "start",
        filterable: true,
        sortable: true,
        value: "discount",
    }, {
        text: "Descuento orig.(%)",
        align: "start",
        filterable: true,
        sortable: true,
        value: "formattedOriginalDiscount",
    },
    {
        text: "",
        value: "actions",
        sortable: false,
    },
]

export default {
    name: 'MaterialesTable',
    props: {
        title: {
            type: String,
            default: 'Materiales'
        },
        materiales: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showOriginalValues: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleDelete(item) {
            this.$emit('deleteItem', item)
        },
        handleEdit(item) {
            this.$emit('editItem', item)
        },
        handleNew() {
            this.$emit('newItem')
        },
        itemRowBackground(item) {
            return item.deleted ? 'error' :
                item.updated ? 'warning' : ''
        },
        getItemClass(item, comparedTo) {
            if (comparedTo === null || comparedTo === undefined) { //no hay datos originales
                return 'noEnPedido'
            }
            return item > comparedTo ? 'mayor'
                : item < comparedTo ? 'menor' : ''
        }
    },
    computed: {
        headers() {
            return this.showOriginalValues ? originalHeaders : defaultHeaders
        },
        materialesFiltered() {
            return this.showOriginalValues ? this.materiales : this.materiales.filter(m => m.qty !== 0)
        }

    }
}
</script>

<style scoped>
.mayor {
    font-weight: bold;
    color: green;
}

.menor {
    font-weight: bold;
    color: red;
}

.noEnPedido {
    font-weight: bold;
    color: #FFC107;
}
</style>
